import { render, staticRenderFns } from "./RatingRuleModal.vue?vue&type=template&id=e0a8a516&scoped=true"
import script from "./RatingRuleModal.vue?vue&type=script&lang=js"
export * from "./RatingRuleModal.vue?vue&type=script&lang=js"
import style0 from "./RatingRuleModal.vue?vue&type=style&index=0&id=e0a8a516&prod&lang=scss&scoped=true"
import style1 from "./RatingRuleModal.vue?vue&type=style&index=1&id=e0a8a516&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a8a516",
  null
  
)

export default component.exports